module.exports = __webpack_public_path__ + "static/media/diamonds-king.cc25f287.png";